import { render, staticRenderFns } from "./ProjectTabPayments.vue?vue&type=template&id=e64a9d64&scoped=true"
import script from "./ProjectTabPayments.vue?vue&type=script&lang=ts"
export * from "./ProjectTabPayments.vue?vue&type=script&lang=ts"
import style0 from "./ProjectTabPayments.vue?vue&type=style&index=0&id=e64a9d64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64a9d64",
  null
  
)

export default component.exports